import React, { FC, useState, useEffect, ReactNode } from 'react';
import cx from 'classnames';
import { Menu } from '@m4b-design/components';
import styles from './index.scss';
import { Contents } from '@/api/seller/serv/oec_seller_learning_center_api';
import { CourseContent } from 'main/src/api/seller/serv/oec_seller_learning_center_api';
import { IconMap } from './index.Mapper';
import { Tea } from '@features/libs/tea';

export interface ContentSTreeProps {
  className?: string;
  autoOpen?: boolean;
  defaultSelectedKeys?: string[];
  defaultOpenKeys?: string[];
  selectedKeys?: string[];
  contents?: Contents[] | CourseContent[];

  accordion?: boolean;
  renderMenuItem?: (name: string, originElement: ReactNode) => ReactNode;
  onClickMenuItem?(key: string, event: any, keyPath: string[]): void;
  onClickSubMenu?(key: string, openKeys: string[]): void;

  menuPage?: string;
  menuModule?: string;
}

const ContentSTree: FC<ContentSTreeProps> = props => {
  const {
    className,
    contents,
    onClickSubMenu,
    accordion: propsAccordion,
    renderMenuItem = (_, originElement) => originElement,
    menuPage,
    menuModule,
    ...other
  } = props;

  const [accordion, setAccordion] = useState<boolean | undefined>(false);
  const [openKeys, setOpenKeys] = useState<string[]>(
    props.defaultOpenKeys ?? [],
  );

  useEffect(() => {
    // arco bug, when set accordion, defaultOpenKeys not work
    setTimeout(() => {
      setAccordion(propsAccordion);
    }, 10);
  }, []);

  const genMenus = (subContents?: Contents[] | CourseContent[]) => {
    if (!subContents) {
      return null;
    }
    return (
      subContents?.map(content => {
        const {
          content_id,
          sub_contents,

          // content_name, content_type for Contents[]
          content_name,
          content_type,
          // type, name  for CourseContent[]
          type,
          name,
        } = content;

        if (!sub_contents?.length) {
          return (
            <Menu.Item
              key={String(content_id)}
              style={{ display: 'flex' }}
              onClick={() => {
                Tea('button_click', {
                  page_name: menuPage,
                  module_name: menuModule,
                  click_for: 'seller_university_menu_item',
                  content_id: content_id,
                  content_name: content_name,
                });
              }}>
              {(content_type === 2 || type === 3) && (
                <img
                  src={require('@/assets/imgs/file.png')}
                  className="h-12 w-12 ml-8 mr-6"
                  style={{ marginTop: 3 }}
                  alt={'menu item image'}
                />
              )}
              {renderMenuItem(
                content_name || name,
                <p
                  className={cx(
                    'line-clamp-2 break-words whitespace-normal pr-8 text-p4-semibold',
                  )}
                  title={content_name || name}>
                  {content_name || name}
                </p>,
              )}
            </Menu.Item>
          );
        } else {
          return (
            <Menu.SubMenu
              key={String(content_id)}
              title={
                <p
                  className={cx(
                    'inline-flex items-center break-all whitespace-pre-wrap',
                  )}>
                  {IconMap[content_id] && (
                    <img
                      className="mr-4 w-14 h-14"
                      src={IconMap[content_id]}
                      alt={'submenu icon'}
                    />
                  )}
                  <span>{content_name || name}</span>
                </p>
              }
              className={cx('text-p4-semibold', {
                [styles.noArrow]: !!IconMap[content_id],
                /* [styles.selected]: openKeys?.includes(String(content_id)), */
              })}
              onClick={() => {
                Tea('button_click', {
                  page_name: menuPage,
                  module_name: menuModule,
                  click_for: 'seller_university_menu_submenu',
                  content_id: content_id,
                  content_name: content_name,
                });
              }}>
              {genMenus(sub_contents)}
            </Menu.SubMenu>
          );
        }
      }) ?? null
    );
  };

  return (
    <div className={cx(styles.sideBar, className)}>
      <Menu
        levelIndent={0}
        accordion={accordion}
        onClickSubMenu={(key, openKeys) => {
          setOpenKeys(openKeys);
          onClickSubMenu?.(key, openKeys);
        }}
        {...other}
        style={{ fontSize: 16, width: '100%' }}>
        {genMenus(contents)}
      </Menu>
    </div>
  );
};

export default ContentSTree;
